export enum ProjectStatus {
  ONGOING = 'ongoing',
  COMPLETED = 'completed',
  ABANDONED = 'abandoned',
  DELAYED = 'delayed',
  BIDDING = 'bidding',
  DRAFT = 'draft',
  BEHIND = 'behind',
}

export const getProjectStatusLabel = (status?: string | null): string => {
  switch (status?.toLowerCase()) {
    case ProjectStatus.ONGOING:
      return 'Active';
    case ProjectStatus.COMPLETED:
      return 'Completed';
    case ProjectStatus.ABANDONED:
      return 'Abandoned';
    case ProjectStatus.DELAYED:
      return 'Delayed';
    case ProjectStatus.BIDDING:
      return 'Bidding';
    case ProjectStatus.DRAFT:
      return 'Draft';
    case ProjectStatus.BEHIND:
      return 'Behind';
    default:
      return status ?? '';
  }
};

export const getDisplayProjectStatus = (
  state?: string | null,
  isBehind?: boolean | null,
): ProjectStatus | string => {
  if (
    isBehind &&
    state?.toLowerCase() === ProjectStatus.ONGOING
  ) {
    return ProjectStatus.BEHIND;
  }
  return (state ?? '').toLowerCase();
};

export const ACTIVE_PROJECT_STATUSES: ProjectStatus[] = [
  ProjectStatus.ONGOING,
  ProjectStatus.COMPLETED,
  ProjectStatus.ABANDONED,
  ProjectStatus.DELAYED,
];

export const isActiveProjectStatus = (status?: string | null): boolean =>
  ACTIVE_PROJECT_STATUSES.includes(
    (status ?? '').toLowerCase() as ProjectStatus,
  );
